import { render, staticRenderFns } from "./adminGeneralSettings.vue?vue&type=template&id=47b67e92"
import script from "./adminGeneralSettings.vue?vue&type=script&lang=js"
export * from "./adminGeneralSettings.vue?vue&type=script&lang=js"
import style0 from "./adminGeneralSettings.vue?vue&type=style&index=0&id=47b67e92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports